import React from 'react'

import { AreaLabelResponse } from 'src/api/gen'
import { MultiSelectChips } from 'src/components/Select'
import { FieldTitle } from 'src/pages/Policies/commons'

interface IVehicleStatesProps {
  data: AreaLabelResponse[]
  disabled?: boolean
  error?: boolean
  handleChange: (value: any) => void
  helperText: React.ReactNode
  id?: string
  title?: string
  value: string[]
}

export default (props: IVehicleStatesProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {props.title ? <FieldTitle title={props.title} /> : null}
      <MultiSelectChips
        id={props.id}
        disabled={props.disabled}
        oneLineSelect={true}
        data={props.data}
        onMultiChange={props.handleChange}
        value={props.value}
        error={props.error}
        helperText={props.helperText}
        withSelectAll={true}
      />
    </div>
  )
}
